import { http } from "./http";
import type { FanClaim, TalentClaimSummary, TalentClaimView } from "../types/claims";

// "Wasn't played?" claims (founder, 2026-10-09). The fan side is public: the
// order id is the access token, the same convention as /orders/:id/pass-counter.
// The talent side needs their session and only ever sees their own orders.
// The set-history upload that answers a claim is ordersApi.uploadHistoryFor.
export const claimsApi = {
  // ── the fan ──
  open: (orderId: string) => http.post<{ claim: FanClaim }>(`/orders/${orderId}/claim`),

  // ── the talent ──
  listOpen: () => http.get<{ claims: TalentClaimSummary[] }>("/orders/claims/open"),
  get: (orderId: string) => http.get<TalentClaimView>(`/orders/${orderId}/claim`),
  refund: (orderId: string) => http.post<{ status: "refunded" }>(`/orders/${orderId}/claim/refund`),
};
